import React from 'react';
import Parameters from 'taiwan_pcb/pcb_fabrication/components/Parameters';
import Price from 'taiwan_pcb/pcb_fabrication/components/Prices';
import Alert from 'taiwan_pcb/pcb_fabrication/components/Alert';

const Fabrication = () => (
  <>
    <Alert />
    <div className="row quote-work-area">
      <div className="col-lg-5 col-xl-4 quoteform-background">
        <div className="parameters">
          <Parameters />
        </div>
      </div>
      <div className="col-lg-7 col-xl-8">
        <div className="pcb-price-section">
          <Price />
        </div>
      </div>
    </div>
  </>
);

export default Fabrication;
